<template>
  <section class="clients-section">
    <h2 class="section-title">{{ $t("hp6.title") }}</h2>
    <div class="clients-wrapper">
      <div class="clients-grid">
        <div
          class="client-item"
          v-for="(client, index) in visibleClients"
          :key="index"
        >
          <a
            v-if="client.src && client.link"
            :href="client.link"
            target="_blank"
            rel="noopener"
          >
            <img :src="client.src" alt="" class="client-img" />
          </a>
          <img
            v-else-if="client.src"
            :src="client.src"
            alt=""
            class="client-img"
          />
          <div v-else class="client-placeholder"></div>
        </div>
      </div>
    </div>

    <div class="illustration">
      <img
        v-if="heroSrc"
        :src="heroSrc"
        :alt="$t('hp6.illustrationAlt')"
        class="illustration-img"
      />
      <div v-else class="illustration-placeholder"></div>
    </div>
  </section>
</template>

<script>
export default {
  name: "HomePage6",
  components: {},
  data() {
    const clients = [
      {
        src: require("@/assets/img/homePage/b1.png"),
        link: "https://super9.bet/",
      },
      {
        src: require("@/assets/img/homePage/kehulogo-4.png"),
        link: "https://play.google.com/store/apps/details?id=com.dragonfang.nzfnrfydut&gl=NZ&hl=en-PK",
      },
      {
        src: require("@/assets/img/homePage/b3.png"),
        link: "https://play.google.com/store/apps/details?id=com.yalla.yallagames&gl=US&hl=en-PK",
      },
      {
        src: require("@/assets/img/homePage/b4.png"),
        link: "https://play.google.com/store/apps/details?id=com.dewmobile.kuaiya.play&gl=YE&hl=en-PK",
      },
      {
        src: require("@/assets/img/homePage/b5.png"),
        link: "https://play.google.com/store/apps/details?id=com.lenovo.anyshare.gps&gl=US&hl=en-PK",
      },
      {
        src: require("@/assets/img/homePage/b6.png"),
        link: "https://play.google.com/store/apps/details?id=com.zzkko&gl=US&hl=en-PK",
      },
      {
        src: require("@/assets/img/homePage/b7.png"),
        link: "https://play.google.com/store/apps/details?id=sg.bigo.live&gl=AT&hl=en-PK",
      },
      {
        src: require("@/assets/img/homePage/b8.png"),
        link: "https://play.google.com/store/apps/details?id=com.mico&gl=AT&hl=en-PK",
      },
      {
        src: require("@/assets/img/homePage/kehulogo-5.png"),
        link: "https://play.google.com/store/apps/details?id=com.roschino.shrine&gl=US&hl=en-PK",
      },
      {
        src: require("@/assets/img/homePage/kehulogo-1.png"),
        link: "https://play.google.com/store/apps/details?id=com.clinkcoindrop.master&gl=US&hl=en-PK",
      },
      {
        src: require("@/assets/img/homePage/kehulogo-2.png"),
        link: "https://play.google.com/store/apps/details?id=com.onlieqxgame.in.act&gl=US&hl=en-PK",
      },
      {
        src: require("@/assets/img/homePage/kehulogo-3.png"),
        link: "https://play.google.com/store/apps/details?id=com.taixiu.itaixiu.diceking&gl=VN&hl=en-PK",
      },
    ]
    clients.push({ src: require("@/assets/img/homePage/b8.png"), link: "" })
    // clients.push({ src: require("@/assets/img/homePage/b12.png"), link: "" })

    return {
      clients,
      heroSrc: require("@/assets/img/homePage/333.png"),
      pageIndex: 0,
      itemsPerPage: 12,
    }
  },
  computed: {
    totalPages() {
      if (this.itemsPerPage <= 0) return 1
      return Math.max(1, Math.ceil(this.clients.length / this.itemsPerPage))
    },
    visibleClients() {
      const start = this.pageIndex * this.itemsPerPage
      const pageItems = this.clients.slice(start, start + this.itemsPerPage)
      const placeholdersNeeded = Math.max(
        0,
        this.itemsPerPage - pageItems.length
      )
      for (let i = 0; i < placeholdersNeeded; i += 1) {
        pageItems.push({ src: "" })
      }
      return pageItems
    },
  },
  mounted() {
    this.updateItemsPerPage()
    window.addEventListener("resize", this.updateItemsPerPage)
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateItemsPerPage)
  },
  methods: {
    updateItemsPerPage() {
      const width = window.innerWidth
      if (width <= 640) {
        this.itemsPerPage = 6
      } else if (width <= 1024) {
        this.itemsPerPage = 8
      } else {
        this.itemsPerPage = 12
      }
      if (this.pageIndex > this.totalPages - 1) {
        this.pageIndex = Math.max(0, this.totalPages - 1)
      }
    },
  },
}
</script>

<style scoped>
.clients-section {
  padding: 56px 0 0;
  background: #f7f9fb;
}

.section-title {
  margin: 0 auto 28px;
  text-align: center;
  font-size: 40px;
  font-weight: bold;
  color: #0b1120;
}

.clients-wrapper {
  position: relative;
  max-width: 1040px;
  margin: 0 auto;
}

.clients-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 24px 36px;
  align-items: center;
  justify-items: center;
  padding: 0 48px;
}

.client-item {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.client-img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.client-placeholder {
  width: 60px;
  height: 60px;
  border-radius: 14px;
  background: #ffffff;
  box-shadow: 0 10px 30px rgba(2, 6, 23, 0.06);
}

.illustration {
  max-width: 1040px;
  margin: 16px auto 0;
  padding: 0 24px;
}

.illustration-img {
  width: 60%;
  height: auto;
  display: block;
  margin: 0 auto;
}

.illustration-placeholder {
  width: 100%;
  height: 420px;
  border-radius: 28px;
  background: linear-gradient(180deg, #eef2ff, #eaf0fb);
  box-shadow: 0 20px 60px rgba(2, 6, 23, 0.08) inset,
    0 12px 32px rgba(2, 6, 23, 0.06);
}

@media (max-width: 1024px) {
  .clients-grid {
    grid-template-columns: repeat(4, 1fr);
    gap: 22px 24px;
    padding: 0 32px;
  }
}

@media (max-width: 640px) {
  .clients-section {
    padding: 40px 0 16px;
  }
  .section-title {
    font-size: 22px;
    margin-bottom: 20px;
  }
  .clients-grid {
    grid-template-columns: repeat(3, 1fr);
    padding: 0 24px;
    gap: 18px;
  }
  .client-item,
  .client-placeholder {
    width: 56px;
    height: 56px;
  }
  .illustration {
    margin-top: 12px;
  }
  .illustration-placeholder {
    height: 320px;
  }
}
</style>
